import List from "./List";
import Form from "./Form";

export default function SalesPage(props: any) {
  return (
    <div className="content_page">
      {(!props.action || props.action == "list") && <List />}

      {props.action &&
        ["create", "edit", "duplicate"].includes(props.action) && (
          <Form action={props.action} />
        )}
    </div>
  );
}
